import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
import { Button } from '../components/ui/button';

const CheckoutCancelPage = () => {
  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center px-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center max-w-md"
      >
        <div className="w-20 h-20 mx-auto mb-6 bg-white/5 rounded-full flex items-center justify-center">
          <XCircle className="w-10 h-10 text-white/30" />
        </div>
        <h1 className="font-heading text-3xl text-white mb-4">Payment Cancelled</h1>
        <p className="font-body text-white/50 mb-8">
          Your payment was cancelled. No charges have been made to your account.
        </p>
        <div className="flex flex-col gap-4">
          <Link to="/cart">
            <Button className="w-full bg-[#c00000] text-white rounded-none py-4 font-heading" data-testid="back-to-cart-btn">
              BACK TO CART
            </Button>
          </Link>
          <Link to="/shop">
            <Button variant="outline" className="w-full bg-transparent border-white/10 text-white rounded-none py-4 font-heading">
              CONTINUE SHOPPING
            </Button>
          </Link>
        </div>
      </motion.div>
    </div>
  );
};

export default CheckoutCancelPage;
